export default __webpack_public_path__ + "static/beautifully-simple-08a0a8c66f136e5de858506d7ccecff9.png";